import { Link } from "react-router-dom";

const AuthMenu = () => {
  return (
    <div>
      <Link to="/signin">Sign in</Link>
    </div>
  );
};

export default AuthMenu;
